<script setup>
import SpanText from '@/Common/Text/SpanText.vue'
import { hoverTextColorClasses } from '@/Common/Text/common'
import { colorClasses } from '@/Common/util/tailwind/colorMap'
import { ChevronRightIcon } from '@heroicons/vue/20/solid'
import { computed } from 'vue'
import { Shimmer } from '../Shimmer'

const props = defineProps({
  open: Boolean,
  running: Boolean,
  label: { type: String, required: true },
  error: Boolean,
  icon: { type: [Object, Function], default: null },
})

defineEmits(['toggle'])

const disclosureColorClasses = computed(() => {
  const color = props.error ? 'text-red-700' : 'text-gray-500'
  return [colorClasses(color), hoverTextColorClasses(color)]
})
</script>

<template>
  <button
    type="button"
    class="-ml-1 inline-flex max-w-full cursor-pointer rounded-sm bg-transparent p-1 text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 motion-safe:transition-colors"
    :class="disclosureColorClasses"
    :aria-expanded="open"
    :data-state="open ? 'open' : 'closed'"
    :title="label"
    @click="$emit('toggle')"
  >
    <SpanText
      class="flex min-w-0 items-center gap-2"
      size="text-sm"
      font="font-normal"
    >
      <component
        :is="icon"
        v-if="icon"
        class="size-4 shrink-0"
        aria-hidden="true"
      />
      <Shimmer
        v-if="running"
        as="span"
        class="min-w-0 truncate text-left"
        data-testid="activity-shimmer"
        >{{ label }}</Shimmer
      >
      <SpanText v-else class="min-w-0 truncate text-left">{{ label }}</SpanText>
      <ChevronRightIcon
        class="size-4 shrink-0 motion-safe:transition-transform"
        :class="{ 'rotate-90': open }"
        aria-hidden="true"
      />
    </SpanText>
  </button>
</template>
